import * as React from 'react';
import { FunctionComponent } from 'react';
import { ReactComponent as ReportsIcon } from '../assets/icons/reports/reports.svg';
import { Button } from '@iba-team/portal-react-components/dist';
import { Trans, useTranslation } from 'react-i18next';
import './DesktopOnly.scss';
import { useNavigate } from 'react-router-dom';


interface Props{
 titleTrans: string,
 descriptionTrans: string
}


export const DesktopOnly: FunctionComponent<Props> = (props) => {
  const {t} = useTranslation();
  const titlePage = props.titleTrans;
  const descrPage = props.descriptionTrans;
  const navigate = useNavigate();
  return(
    <div className={'reports_empty_page'}>
      <div className={'reports_empty_page_title'}>
        <ReportsIcon/>
        <h3>
          <Trans i18nKey="emptyPageTitle" page={titlePage}>
            {{titlePage}}
          </Trans>
        </h3>
      </div>
      <h4>
        <Trans i18nKey="emptyPageDescription" page={descrPage}>
          {{descrPage}}
        </Trans>
      </h4>
      <Button theme={{variant: 'primary', color: 'theme'}} onClick={()=> navigate(-1)}>
        {t('goPrevious')}
      </Button>
    </div>
  );
};
